import { Component } from '@angular/core';
import { AlertSheet, AlertSheetButton } from '@app/@shared/models/alert.model';
import { IonicModule, ModalController, NavController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [IonicModule, TranslateModule],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
})
export class AlertComponent {
  alert!: AlertSheet;
  constructor(private navCtrl: NavController, private modalCtrl: ModalController) {}
  itemClick(b: AlertSheetButton) {
    // const b = this.alert.buttons.find((bt) => bt.to);
    if (b.to) this.navCtrl.navigateForward([b.to]);
    this.modalCtrl.dismiss();
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
